import { sendMessage } from '../../../common/message/sendMessage'
import { listenMessage } from '../../../common/message/listenMessage'
import {
  requestThemeSyncAction,
  THEME_CHANGE_EVENT,
  THEME_STORAGE_KEY,
  type RequestThemeSyncAction,
} from './actions'
import { Theme, isTheme } from './index'

export const broadcastTheme = (theme: Theme) => {
  sendMessage({
    action: {
      type: THEME_CHANGE_EVENT,
      theme,
    },
  })
}

export const onThemeSyncRequest = () =>
  listenMessage<RequestThemeSyncAction>({
    whitelist: [requestThemeSyncAction],
    onMessage: () => {
      const storedTheme = localStorage.getItem(THEME_STORAGE_KEY)
      const resolvedTheme = isTheme(storedTheme) ? storedTheme : Theme.LIGHT
      broadcastTheme(resolvedTheme)
    },
  })
